import { toast } from "sonner"

const TOS_MESSAGE_PREFIX = /^this prompt violates our terms of service:\s*/i

function splitTosUserMessage(message: string): { headline: string; reason: string } {
  const trimmed = message.trim()
  const withoutPrefix = trimmed.replace(TOS_MESSAGE_PREFIX, "").trim()
  if (withoutPrefix.length > 0) {
    return {
      headline: "Terms of Service violation",
      reason: withoutPrefix,
    }
  }
  return {
    headline: "Terms of Service violation",
    reason: trimmed.length > 0 ? trimmed : "This prompt is not allowed under our Terms of Service.",
  }
}

/**
 * High-visibility red toast for prompt moderation / Terms of Service blocks.
 * `message` is usually the API string (`This prompt violates our Terms of Service: …`).
 */
export function toastTosViolation(message: string) {
  const { headline, reason } = splitTosUserMessage(message)

  toast.error(headline, {
    description: reason,
    duration: 15_000,
    classNames: {
      toast:
        "!border-0 !rounded-lg !bg-red-600 !text-white [&_[data-icon]]:!text-white [&_[data-content]]:!text-white !shadow-lg !shadow-black/50",
      title: "!text-white !font-semibold !text-[15px]",
      description: "!text-white/95 !text-sm !leading-relaxed !font-normal !opacity-100",
      actionButton: "!text-white",
      cancelButton: "!text-white/90",
      closeButton: "!text-white/90 !border-white/20",
    },
  })
}
